import { connect } from 'react-redux';
import UserAvatar from '../../components/basic/UserAvatar';

const mapStateToProps = state => ({
  user: state.user,
});

export default connect(mapStateToProps)(UserAvatar);
